// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer__link {\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  min-height: 40px;\n}\n.drawer__link:hover, .drawer__link:focus {\n  text-decoration: underline;\n}\n.mainloader {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
